import Vue from 'vue';
import axios from 'axios/dist/axios.js';
import { urlDontRequireAuth, clearUserData, loginSuccessHandler, getUserData } from "./util/helpers";
import VeeValidate from 'vee-validate';
import _ from 'lodash';
import * as filters from './util/filters';
import Moment from 'moment';
import "moment-timezone";
import VModal from 'vue-js-modal';
import VueMeta from "vue-meta"
import VueScrollTo from 'vue-scrollto';
import SocialSharing from 'vue-social-sharing';
import router from "./router/routes";

import "./util/jquery-helpers";
Vue.use(SocialSharing);
Vue.use(VeeValidate);
Vue.use(VModal);
Vue.use(VueScrollTo);
Vue.use(VueMeta);

// Register global utility filters.
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
});

// Global instances
// If you want that a package or variable be exposed globally put it here
window.axios = axios;
window._ = _;
window.moment = Moment;
window.Vue = Vue;
window.EventBus = new Vue();
window.nzxt = {
    countries: require("./util/countries").default
}
window.getCssVariable = variable => {
    return getComputedStyle(document.documentElement).getPropertyValue(`--${variable}`);
}

// Remove production message from the developer console
Vue.config.productionTip = false;

// Check if there a user logged with the social login
const socialAuthUser = window.Cookies.get("social_auth_user");

if (socialAuthUser) {
    const user = getUserData();
    loginSuccessHandler(user);
    localStorage.setItem("userData", JSON.stringify(user));
    Cookies.remove("social_auth_user", { domain: process.env.MIX_COOKIE_DOMAIN });
}

// Returns the data from the current logged user
try {
    window.userData = () => JSON.parse(localStorage.getItem("userData") || "{}");

    if (localStorage.getItem("pos-mode-test")) {
        window.CONFIG.POS_MODE = true;
    }
} catch (e) {
    window.userData = () => JSON.parse("{}");
}

// Sets a default base URL to the global instance of axios
axios.defaults.baseURL = window.CONFIG.API_URL;

axios.interceptors.request.use(config => {

    if (urlDontRequireAuth(config)) {
        return config;
    }

    // Sets the Authorization header before request is sent
    if (Cookies.get("token")) {
        if (!Cookies.get("cookies_id")) {
            return sessionExpired();
        }
        config.headers.common["Authorization"] = Cookies.get("token");
    }

    return config;
}, error => {
    // Do something with request error
    return Promise.reject(error);
});

axios.interceptors.response.use(response => {
    if (response && response.data) {
        // Update the userData token if the response has one otherwise we create the obj with the token
        if (response.data.token){
            Cookies.set("token", response.data.token, { domain: process.env.MIX_COOKIE_DOMAIN });
        }
    }

    return response;
}, error => {
    if (error.response) {
        const shouldCleanSession = error.response.data[0] == "Expired token"
            || _.has(error, "response.data.status.message") && ["User not found", "Invalid token"].includes(error.response.data.status.message);

        if (shouldCleanSession) {
            return sessionExpired();
        }
    }

    return Promise.reject(error);
});


function sessionExpired() {
    clearUserData();
    sessionStorage.setItem("session_expired", true);
    if (!location.search.includes("login")) {
        EventBus.$emit("session-expired");
        router.push({ name: "home" });
    }
}
